<template>
  <BuildingPage title="报告详情" description="详情页采用“基础信息 + 流程步骤 + 内容区域 + 侧边操作”布局，方便承接后续报告预览和审批操作。">
    <div class="report-detail">
      <!-- 详情页先把信息阅读区和操作区拆开，后续接接口时可以平滑扩展。 -->
      <el-card shadow="never" class="page-card">
        <div class="report-detail__header">
          <div>
            <div class="report-detail__code">RP-202604-001</div>
            <h2>一季度经营分析报告</h2>
            <p>模板：经营分析标准版 · 负责人：陈静 · 更新时间：2026-04-16 10:21</p>
          </div>
          <span class="rm-tag rm-tag--warning">审核中</span>
        </div>
        <el-steps :active="2" finish-status="success">
          <el-step title="草稿"></el-step>
          <el-step title="内容确认"></el-step>
          <el-step title="审核中"></el-step>
          <el-step title="归档"></el-step>
        </el-steps>
      </el-card>

      <div class="report-detail__content">
        <el-card shadow="never" class="page-card">
          <div class="report-detail__section-title">内容预览</div>
          <EmptyState title="预览区域待接入" description="后续可在这里接入报告正文预览、附件列表、对比版本和审批意见。" icon="el-icon-reading"></EmptyState>
        </el-card>
        <el-card shadow="never" class="page-card report-detail__aside">
          <div class="report-detail__section-title">快捷操作</div>
          <el-button type="primary" plain>提交审核</el-button>
          <el-button>导出报告</el-button>
          <el-button>查看版本</el-button>
        </el-card>
      </div>
    </div>
  </BuildingPage>
</template>

<script>
import EmptyState from '@/components/EmptyState.vue'
import BuildingPage from '@/views/report/building/building.vue'

export default {
  name: 'ReportDetailPage',
  components: {
    EmptyState,
    BuildingPage
  }
}
</script>

<style lang="scss" scoped>
.report-detail__header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
}

.report-detail__header h2 {
  margin: 8px 0;
}

.report-detail__header p,
.report-detail__code {
  color: var(--rm-color-text-secondary);
}

.report-detail__content {
  margin-top: 16px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 280px;
  gap: 16px;
}

.report-detail__section-title {
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 600;
}

.report-detail__aside {
  ::v-deep .el-card__body {
    display: grid;
    gap: 12px;
  }
}

@media screen and (max-width: 1200px) {
  .report-detail__content {
    grid-template-columns: 1fr;
  }
}
</style>
